import mockedCountries from '../../../fixtures/countriesFixture.json';
import { CommunicationCultureCountry } from '../CountryRepository';
export default class CountryRepositoryMock {
  fetchAll(): Promise<CommunicationCultureCountry[]> {
    return Promise.resolve(mockedCountries as CommunicationCultureCountry[]);
  }
}
